module.exports = __webpack_public_path__ + "static/media/mtn.b3ef0e7a.png";